<template>
  <form
    class="simple-create-form"
    @submit.prevent="submitForm"
  >
    <h3>
      Opret ny WADA klassifikering
    </h3>
    <Box>
      <BaseInput
        label="Navn"
        v-model="form.name"
        :disabled="loading"
      />
      <baseInput
        label="Link"
        v-model.trim="form.link"
        placeholder="https://example.com"
        :disabled="loading"
      />

      <p
        class="wada-small"
        v-if="form.link.length > 0 && $v.form.link.$invalid"
      >
        Format: https://example.com
      </p>
      <BaseFormField label="Status">
        <BaseSelect
          label="name"
          :placeholder="form.deleted | IsDeleted"
          @select="updateDeleted"
          :options="[{value: true, name: 'Slettet'}, {value: false, name: 'Aktivt'}]"
          :disabled="loading"
        />
      </BaseFormField>
      <div class="simple-create-form__inline">
        <BaseButton
          label="Opret ny WADA klassifikering"
          :disabled="loading || $v.$invalid"
        />
        <div>
          <BaseSpinner
            height="40px"
            width="40px"
            v-if="loading"
          />
        </div>
      </div>
    </Box>
  </form>
</template>

<script>
import { required, url } from 'vuelidate/lib/validators';
import BaseSelect from '../../BaseSelect.vue';
import BaseFormField from '../../BaseFormField.vue';
import BaseSpinner from '../../BaseSpinner.vue';
import BaseButton from '../../BaseButton.vue';
import Box from '../../Box.vue';
import BaseInput from '../../BaseInput.vue';
import WADAClassificationService from '../../../services/WADAClassificationService';
import IsDeleted from '../../../filters/IsDeleted';

export default {
    name: 'CreateWADAClassificationForm',
    components: {
        BaseInput, Box, BaseButton, BaseSpinner, BaseFormField, BaseSelect,
    },
    filters: { IsDeleted },
    data() {
        return {
            loading: false,
            form: {
                name: '',
                link: '',
                deleted: false,
            },
        };
    },
    validations: {
        form: {
            name: { required },
            link: { required, url },
        },
    },
    methods: {
        resetForm() {
            this.form.name = '';
            this.form.link = '';
            this.form.deleted = false;
        },
        updateDeleted(e) {
            this.form.deleted = e.value;
        },
        async submitForm() {
            this.$v.$touch();

            if (this.$v.$invalid) {
                this.$snotify.error('Ikke alle felter er udfyldt korrekt.');
                return;
            }

            try {
                this.loading = true;

                const payload = await WADAClassificationService.create(this.form);

                this.$snotify.success(`${payload.name} er oprettet`);
                this.loading = false;
                this.$emit('created', payload);
                this.resetForm();
            } catch (error) {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.simple-create-form {
    max-width: 500px;
    margin-top: 50px;

    &__inline {
        display: flex;

        svg {
            margin-left: 10px;
        }
    }
}

.wada-small {
    margin-bottom: 10px;
    font-style: italic;
    font-size: 11px;
}
</style>
